module.exports = __webpack_public_path__ + "media/images/views/home/home-features-icon-data-20369c83be32ee2b3902c4a4df31722b.png";